import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { openNativeSettings } from '../../utils/nativeAppBridge';
import './Header.css';

function Header({ onOpenModal, user }) {
  const location = useLocation();

  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__brand">
          <div className="header__brand-content">
            <div className="header__brand-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                <path d="M8 7h8M8 11h8M8 15h6"/>
              </svg>
            </div>
            <div className="header__brand-text">
              <h1 className="header__title">Remori</h1>
              <span className="header__tagline">A return to memory</span>
            </div>
          </div>
        </Link>

        <nav className="header__nav">

          <Link
            to="/insights"
            className={`header__icon-btn ${location.pathname === '/insights' ? 'header__icon-btn--active' : ''}`}
            title="View insights"
            aria-label="View insights"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 3v18h18" />
              <path d="M18 17V9M13 17v-6M8 17v-3" />
            </svg>
          </Link>

          <Link
            to="/settings"
            onClick={openNativeSettings}
            className={`header__icon-btn ${location.pathname === '/settings' ? 'header__icon-btn--active' : ''}`}
            title="Settings"
            aria-label="Settings"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </Link>

          <Link
            to="/profile"
            className={`header__icon-btn header__icon-btn--profile ${location.pathname === '/profile' ? 'header__icon-btn--active' : ''}`}
            title="Profile"
            aria-label="Profile"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" />
            </svg>
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
